export enum MailID {
  DoNotMail = 'do_not_mail',
  MailAndView = 'mail_and_view',
  MailOnly = 'mail_only',
}

// TODO здесь должны быть только id фильтров, которые находятся в _filter-compilations
// Нужно почистить это все, и чтоб ддругие кабинеты не сломались

export enum ID {
  details = 'details',
  city = 'city',
  district = 'district',
  orgType = 'orgType',
  groupBy = 'groupBy',
  org = 'org',
  periodFrom = 'periodFrom',
  periodTo = 'periodTo',
  periodDateFormat = 'periodDateFormat',
  email = 'email',
  mailing = 'mailing',
  gender = 'gender',
  identifier = 'identifier',
  identifiersType = 'identifiersType',
  allowances = 'allowances',
  attend = 'attend',
  subsidy = 'subsidy',
  afterschool = 'afterschool',
  orgsOrUser = 'orgsOrUser',
  customerType = 'customerType',
  studentsType = 'studentsType',
  studentsStatus = 'studentsStatus',
  customerSearch = 'customerSearch',
  classesList = 'classesList',
  campGroupList = 'campGroupList',
  dayCareList = 'dayCareList',
  seasonShiftList = 'seasonShiftList',
  parents = 'parents',
  studentList = 'studentList',
  employeeList = 'employeeList',
  birthday = 'birthday',
  dietFood = 'dietFood',
  dietFoodTypes = 'dietFoodTypes',
  snils = 'snils',
  schoolYear = 'schoolYear',
  statementStatuses = 'statementStatuses',
  operationsType = 'operationsType',
  operationAge = 'operationAge',
  year = 'year',
  month = 'month',
  postEmployee = 'postEmployee',
  roleEmployee = 'roleEmployee',
  classLeader = 'classLeader',
  date = 'date',
  invisibleDateFormat = 'invisibleDateFormat',
  foodType = 'foodType',
  additionalInfo = 'additionalInfo',
  encashmentsStatus = 'encashmentsStatus',
}
